import {UcoastEl} from '@/scripts/core/UcoastEl'
import {getAttributeOrThrow, qsRequired} from '@/scripts/core/global'

type GcmsBatchComponent = {
    chemical_value: number
    chemical: string
    family: string
}

type GcmsDataItem = {
    name: string
    specific_gravity_20: string | null
    relative_density_20: string | null
    refractive_index_20: string | null
    optical_rotation_20: string | null
    flash_point: string | null
    formatted_date: string
    batch_components: GcmsBatchComponent[]
    old_batch_components: GcmsBatchComponent[]
    country: string
}

export class GcmsData extends UcoastEl {
    static htmlSelector = 'gcms-data'
    handle: string
    outerContainerId: string
    container: HTMLElement

    constructor() {
        super()
        this.handle = getAttributeOrThrow('data-uc-gcms-product-handle', this)
        this.container = qsRequired('[data-uc-gcms-container]', this)
        this.outerContainerId = getAttributeOrThrow('data-uc-gcms-outer-container-id', this)
        void this.load()

    }

    override connectedCallback() {
        super.connectedCallback()
    }

    async load() {
        const data = await this.fetchData()

        if (data.length  > 0) {
            let html = ''
            data.forEach((batch) => {
                html += this.constructLinkFromData(batch)
            })
            this.container.innerHTML = html

            const parentAccordion = this.closest('basic-accordion')
            if (parentAccordion) {
                const heightControlledElement = this.closest('[data-uc-accordion-height-controlled]')
                if (heightControlledElement instanceof HTMLElement) {
                    heightControlledElement.style.maxHeight = `${heightControlledElement.scrollHeight}px`
                }
            }
        } else {
            this.container.innerHTML = `<p>No GCMS data available</p>`
        }
    }

    async fetchData(): Promise<GcmsDataItem[]> {
        const response = await fetch(
            `https://data.aromatics.com/batch_history/by_batch/${this.handle}`
        ).then((response) => response.json())
        return response as GcmsDataItem[]
    }

    constructLinkFromData(batch: GcmsDataItem): string {
        return `<a href="/pages/gcms?oil=${this.handle}&batch${batch.name}" class="gcms-data-link block no-underline underline-always block w-max-contain">
${batch.name}
			</a>`
    }
}
